import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@futuredev/shared-auth';

interface PasswordChangeGuardProps {
  children: React.ReactNode;
}

function PasswordChangeGuard({ children }: PasswordChangeGuardProps) {
  const { user, mustChangePassword, loading } = useAuth();
  const location = useLocation();

  if (loading) return <>{children}</>;

  const isValidUser = user && (user.id || user.email);

  if (isValidUser && mustChangePassword && location.pathname !== '/change-password') {
    return (
      <Navigate
        to="/change-password"
        replace
        state={{ from: location.pathname + location.search }}
      />
    );
  }

  if (!mustChangePassword && location.pathname === '/change-password') {
    if (isValidUser) {
      const fallback = (location.state as { from?: string } | null)?.from || '/dashboard';
      return <Navigate to={fallback} replace />;
    }
    return <Navigate to="/login" replace />;
  }

  if (!isValidUser && mustChangePassword) return <>{children}</>;

  return <>{children}</>;
}

export default PasswordChangeGuard;
